"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (values, schema) => {
    const result = {};
    Object.keys(schema.fields).forEach(key => (result[key] = values[key]));
    return result;
};
//# sourceMappingURL=applySchema.js.map